
import { Link } from 'react-router-dom';
import { useUser } from '@/firebase';
import { Skeleton } from '../ui/skeleton';
import { Avatar, AvatarFallback, AvatarImage } from '../ui/avatar';
import { Button } from '../ui/button';
import { LogIn } from 'lucide-react';

export function AuthStatus() {
  const { user, isUserLoading } = useUser();

  if (isUserLoading) {
    return (
      <Skeleton className="h-9 w-9 rounded-full" />
    );
  }

  if (user) {
    return (
      <Link to="/profile">
        <Avatar className="h-9 w-9">
          {user.photoURL && <AvatarImage src={user.photoURL} alt={user.displayName || 'User'} />}
          <AvatarFallback>{user.email?.[0].toUpperCase()}</AvatarFallback>
        </Avatar>
      </Link>
    );
  }

  return (
    <Button asChild variant="ghost" size="sm">
      <Link to="/login">
        <LogIn className="mr-2 h-4 w-4" />
        Log In
      </Link>
    </Button>
  );
}
